module.exports = __webpack_public_path__ + "img/macbook-gold.6eafce3e.png";